import { getConfig } from '@chegg-web-tools/config-plugin';
import { getClient, SessionData, StateUpdateData } from '@chegg/rio-sdk-web';
import type { EventSchemas } from '@chegg/one-auth';
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

// const rioNameSpace = getConfig('rioConfig').appId;

export function getRioClient() {
  return getClient<EventSchemas>();
}

export function initializeRio() {
  // sets a cvid cookie if none exists.
  // once rio is initialized it will sync our generated cvid cookie with the one from rio's cvid service
  setCVID();
  getClient<EventSchemas>().init(getRioConfig());
}

export function getRioConfig() {
  const config: SessionData = {
    ...getConfig('rioConfig'),
    cheggUuid: getUUID(),
    authState: 'unknown',
    // useLocalPort: true, // useful for debugging rio events locally. see https://chegg.atlassian.net/wiki/spaces/DEVX/pages/184290962/Local+Rio+Event+Validation
  };
  return config;
}

export function getUUID() {
  let uuid = null;
  try {
    uuid = JSON.parse(
      atob(
        document.cookie
          .split('; ')
          .filter((c) => c.substr(0, 8) === 'id_token')[0]
          .split('.')[1]
      )
    ).sub;
    return uuid;
  } catch (error) {
    //
  }
}

export async function sendRioEvent(type: EventSchemas['type'], data: EventSchemas['data']) {
  try {
    await getRioClient().sendEvent({ type, data, eventVersion: 3 });
  } catch (error) {
    // todo new relic event
  }
}

export function updateRioState(state: StateUpdateData) {
  getRioClient().updateState(state);
}

/**
 * This function sets a CVID cookie in case there's no one already defined.
 * CVID is a uuidv4 string that serves as the user unique identifier which later passed to Optimizely.
 * https://chegg.atlassian.net/wiki/spaces/DEVX/pages/800136499/Chegg+Visitor+ID+Spec
 * https://chegg.atlassian.net/wiki/spaces/EXP/pages/2752217154/What+User+ID+to+use+when+allocating+OFS+experiments
 * this is needed in order to properly allocating users to buckets.
 * https://docs.developers.optimizely.com/full-stack/docs/how-bucketing-works#how-users-are-bucketed
 */
function setCVID() {
  if (typeof window !== undefined && !Cookies.get('CVID')) {
    const CVID = uuidv4();
    /* TODO update urls to be tld aware */
    const domain = process.env.CHEGG_ENV === 'prod' ? 'chegg.com' : '.cheggnet.com';
    Cookies.set('CVID', CVID, { domain, expires: Infinity });
  }
}
